import React from "react";
import { Lock } from "lucide-react";

// Web sticker badge. Renders the designer's exported artwork from
// /public/stickers/<key>.png — each file already contains its own tinted
// circle, so nothing is drawn behind it. Native twin: src/components/
// StickerMedallion.tsx (same files, bundled via require).

// Keys with artwork. Anything else falls through to the locked treatment
// rather than requesting a 404 image.
const ART_KEYS = new Set([
  "first_star", "perfect_ten", "quiz_whiz", "super_brain", "first_show",
  "movie_buff", "on_a_roll", "week_star", "numbers_hero", "letters_hero",
  "colors_hero", "shapes_hero", "social_hero", "language_hero",
  "bedtime_hero", "creativity_hero",
]);

export function StickerMedallion({
  stickerKey,
  earned,
  size = 64,
}: {
  stickerKey: string;
  earned: boolean;
  size?: number;
}) {
  if (!earned || !ART_KEYS.has(stickerKey)) {
    return (
      <div
        style={{
          width: size,
          height: size,
          borderRadius: "50%",
          background: "var(--bg-warm)",
          border: "2px dashed var(--line)",
          display: "grid",
          placeItems: "center",
          color: "var(--ink-3)",
        }}
      >
        <Lock size={Math.round(size * 0.38)} strokeWidth={2.25} />
      </div>
    );
  }

  return (
    <img
      src={`/stickers/${stickerKey}.png`}
      alt=""
      width={size}
      height={size}
      style={{ display: "block", objectFit: "contain" }}
    />
  );
}

export default StickerMedallion;
